module.exports = __webpack_public_path__ + "media/images/peb/8mm/peb_f-403b818b215d183eb6ce40f641a18494.png";